import { orderBy } from 'lodash-es';
import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';
import { theme } from '@dojo/framework/core/middleware/theme';
import { create, destroy, v, w } from '@dojo/framework/core/vdom';
import { PretestCard } from '@holmescorp/card';
import { Keys } from '@holmescorp/common';
import { createNlsMiddleware, documentapi, recommended, userstate } from '@holmescorp/lcc-state';
import { mayTriggerML } from '@holmescorp/ml';
import { resourceDitabookSelector } from '@holmescorp/resource-parser';
import { tocHide, tocShow } from '@holmescorp/table-of-contents';
import css from '../css/chooser.m.css';
import { svc } from '../support/svc';
const icache = createICacheMiddleware();
const nls = createNlsMiddleware('ditabook');
const factory = create({
    icache,
    nls,
    theme,
    userstate,
    recommended,
    documentapi,
    destroy
}).properties();
export const AssessmentChooser = factory(({ properties, middleware: { icache, nls, theme, userstate, recommended, documentapi, destroy } }) => {
    tocHide();
    destroy(() => tocShow());
    const themeCss = theme.classes(css);
    const { xqa, switchView, setTitle } = properties();
    const { messages: { study_title = '[ditabook] study_title', myStudyPlan = '[ditabook] myStudyPlan', assessment_chooser_a11y_description = '[ditabook] assessment_chooser_a11y_description' } } = nls();
    const { get, path } = userstate;
    const quizPattern = (() => {
        return get(path('quizPattern'));
    })();
    const site = window.hcstatic.portal_site;
    const pretests = icache.getOrSet('quizzes', async () => {
        const parms = { site };
        if (quizPattern) {
            parms['menu'] = quizPattern;
        }
        return await svc.pretest_quizzes(parms);
    });
    if (pretests) {
        const quizState = icache.getOrSet('status', async () => {
            const quizids = pretests.map((pretest) => pretest.id);
            return await svc.quiz_state({ site, quizids });
        });
        if (quizState) {
            const results = Object.assign({}, ...recommended.assessResults().map((result) => ({ [result.topichead]: result.percent })));
            const len = pretests.length;
            const sorted = orderBy(pretests.map((pretest, index) => {
                const { id, domain } = pretest;
                const status = {
                    active: quizState[id].combined_status.active,
                    complete: quizState[id].combined_status.complete
                };
                const quizId = id.split(/-s?cp$/)[0];
                const result = results[domain];
                const card = w(PretestCard, { quizId, domain, status, xqa: `${quizId}-card` });
                const order = result ? index + len : index;
                return { order, card };
            }), ['order'], ['asc']);
            const cards = sorted.map((item) => item.card);
            const pathid = quizPattern && quizPattern.length > 0 ? quizPattern[`path-${quizPattern}`] || '' : '';
            documentapi.setTitle(assessment_chooser_a11y_description);
            return v('div', { xqa, classes: [themeCss.root, theme.variant()] }, [
                w(resourceDitabookSelector, {
                    topic: 'assess_title',
                    key: 'assess-title',
                    classes: [themeCss.title],
                    formatting: { pathid }
                }),
                v('div', { classes: [themeCss.cards] }, cards),
                v('div', {
                    xqa: 'my-study-plan-nav',
                    classes: [themeCss.studyplan],
                    onclick: (event) => {
                        event.stopImmediatePropagation();
                        mayTriggerML();
                        setTitle && setTitle(study_title);
                        switchView('study');
                    },
                    onkeydown: (event) => {
                        switch (event.key) {
                            case Keys.Enter:
                            case Keys.Space:
                            case Keys.Spacebar:
                                event.preventDefault();
                                mayTriggerML();
                                setTitle && setTitle(study_title);
                                switchView('study');
                        }
                    }
                }, [v('span', {}, [myStudyPlan])])
            ]);
        }
    }
    return null;
});
export default AssessmentChooser;
